<script setup lang="ts">
import { ref, onMounted, onUnmounted } from "vue";

defineProps<{
  text: string;
  color?: string; // CSS color value
}>();
const points = ref("");
let interval: any;

onMounted(() => {
  interval = setInterval(() => {
    points.value =
      points.value === ""
        ? "."
        : points.value === "."
        ? ".."
        : points.value === ".."
        ? "..."
        : "";
  }, 400);
});

onUnmounted(() => {
  clearInterval(interval);
});
</script>

<template>
  <div
    class="d-flex fw-medium"
    :style="
      color && {
        color,
      }
    "
  >
    {{ text }}
    <div style="width: 15px">
      {{ points }}
    </div>
  </div>
</template>

<style lang="scss" scoped></style>
